import { CallAPIGetPromise } from 'Common/commaon';
import { PropertyManager } from 'components/PropertyManager'
import React, { useEffect, useState } from 'react'
import { getDecodeId } from 'slices/userProfile/thunk';

const AddPropertyManager = () => {
    const [properties, setProperties] = useState<any[]>([]);
    const [selectedPropertyId, setSelectedPropertyId] = useState<string | null>(null);
   const [refresh,setRefresh]=useState(false)
    const handleAddProperty = (propertyData: Omit<any, 'property_id' | 'createdAt'>) => {
      setRefresh(r=>!r)
      };

      const handleUpdateProperty = (id: string, updates: Partial<any>) => {
        setRefresh(r=>!r)
      };
      const handleDeleteProperty = (id: string) => {
        setRefresh(r=>!r)
      };
      const handleSetPrimaryProperty = (id: string) => {
        setRefresh(r=>!r)
      };

      useEffect(()=>{
CallAPIGetPromise(`/profile/properties/get/${getDecodeId()}`).then((res:any)=>{
  setProperties(res)
}).catch((e:any)=>{
    console.log(e)
})
      },[refresh])
  return (
    <div className='tailwind-prefix page-content'>
    <PropertyManager
    properties={properties}
    currentUserId={getDecodeId()}
    onAddProperty={handleAddProperty}
    onUpdateProperty={handleUpdateProperty}
    onDeleteProperty={handleDeleteProperty}
    onSetPrimary={handleSetPrimaryProperty}
  />
    </div>

  )
}

export default AddPropertyManager